import React, { useContext, useEffect, useState } from "react";
import { EnquiryValidation } from "../utills/Validation";
import { ContextStore } from "../../App";
import InputsData from "../utills/InputsData";
import axios from "axios";
import { DomainUrl } from "../utills/CommonData";
import FeedbackSuccess from "./FeedbackSuccess";
import { Link } from "react-router-dom";

const Enquiry = () => {
  const [errors, setErrors] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  const { enquiryFormData, setEnquiryFormData } = useContext(ContextStore);
  const { enquiryInputs } = InputsData();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEnquiryFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(false);
      setEnquiryFormData({
        name: "",
        email: "",
        phone: "",
        pincode: "",
        enquiryType: "",
        message: "",
      });
    }, 5000);
    return () => clearInterval(timer);
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = EnquiryValidation(enquiryFormData);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      try {
        const response = await axios.post(
          `${DomainUrl}/enquiry`,
          enquiryFormData,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        // console.log(response);
        if (response.data.success) {
          setIsOpen(true);
          console.log("Enquiry Form submitted successfully");
        } else {
          console.error("Server responded with an error:", response.data);
        }
      } catch (error) {
        console.error("Error submitting the enquiry form", error);
      }
    }
  };
  const handleRadioChange = (e) => {
    setEnquiryFormData({
      ...enquiryFormData,
      enquiryType: e.target.value,
    });
  };
  return (
    <>
      {!isOpen ? (
        <form onSubmit={handleSubmit} className="flex max-w-md flex-col gap-3 ">
          <div className="flex flex-col gap-2">
            <label className="block mt-4 font-semibold w-full  rounded-lg focus:outline-none focus:ring-2 focus:ring-error">
              What is your enquiry about?
            </label>
            <div className="flex gap-4  accent-error  ">
              <label className="flex items-center ">
                <input
                  type="radio"
                  value="Product Related"
                  checked={enquiryFormData?.enquiryType === "Product Related"}
                  className="mr-2"
                  onChange={handleRadioChange}
                />
                Product Related
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  value="Service Related"
                  checked={enquiryFormData?.enquiryType === "Service Related"}
                  className="mr-2"
                  onChange={handleRadioChange}
                />
                Service Related
              </label>
            </div>
            {errors.enquiryType && (
              <p className="text-error text-sm">{errors.enquiryType}</p>
            )}
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="message" className="font-semibold">
              Please let us know in detail
            </label>
            <textarea
              type="text"
              onChange={handleInputChange}
              name="message"
              id="message"
              value={enquiryFormData?.message}
              placeholder="Describe your content here..."
              className="border border-neutral text-black rounded p-2 focus:outline-none focus:ring-2 focus:ring-error"
            />
            {errors.message && (
              <p className="text-error text-sm">{errors.message}</p>
            )}
          </div>
          <div className="grid md:grid-cols-2  md:gap-2 gap-3">
            {enquiryInputs.map((input) => {
              return (
                <div key={input?.id} className="flex flex-col gap-2">
                  <label htmlFor={input?.name} className="font-semibold ">
                    {input?.label}
                  </label>
                  <input
                    type={input?.type}
                    name={input?.name}
                    id={input?.name}
                    placeholder={input?.placeholder}
                    onChange={handleInputChange}
                    value={input?.value || ""}
                    className="rounded-full text-black border-neutral border focus:outline-none focus:ring-2 focus:ring-error p-2"
                  />
                  {errors[input.name] && (
                    <p className="text-error text-sm">{errors[input.name]}</p>
                  )}
                </div>
              );
            })}
          </div>
          <button
            type="submit"
            className="border border-neutral rounded-full w-32 mx-auto hover:bg-white font-semibold hover:text-black mt-4 p-2"
          >
            Submit
          </button>
        </form>
      ) : (
        <div className="flex items-center justify-center h-screen">
          <div className="bg-white p-6 rounded-2xl shadow-lg text-center max-w-md">
            <h2 className="text-2xl font-bold text-green">Thank You! 🎉</h2>
            <p className="text-darkGray mt-3">
              Your enquiry has been submitted successfully. We appreciate your
              time and will get back to you soon.
            </p>
            <button className="mt-5 px-4 py-2 bg-green text-white rounded-lg  transition">
              <Link to="/">Back to Home</Link>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Enquiry;
